import { createContext } from "react";
import { Router } from "@remix-run/router";
import { MixPanelType } from "../types/mixPanel.types";

export interface MFEContextType {
  mixPanel: MixPanelType;
  router: Router;
}

export const MFEContext = createContext({} as MFEContextType);

type Props = {
  mixPanel: MixPanelType;
  router: Router;
  children: React.ReactNode;
};

const MFEProvider = ({ children, ...props }: Props) => {
  return <MFEContext.Provider value={props}>{children}</MFEContext.Provider>;
};

export default MFEProvider;
